import React, { useReducer } from 'react'
import { PickingReportContext } from '../Context/usePickingReport'
import {
  initialState,
  pickingReportReducer
} from '../reducer/pickingReportReducer'

/*
Copyright 2022-06-08 por Jorge Parrado Ecomsur Holding S.A ©
Detalle: Crea reporte de picking
*/

export const PickingReportProvider = ({ children }: any) => {
  const [state, dispatch] = useReducer(pickingReportReducer, initialState)

  const value = { state, dispatch }
  return (
    <PickingReportContext.Provider value={value}>
      {children}
    </PickingReportContext.Provider>
  )
}
